export default [
  {
    path: '/notification-manuals',
    name: 'notification-manual',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification-manual/index.vue')
  }
]
